var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 20 20","fill":"none"}},[_c('path',{attrs:{"d":"M8.00008 6H14.0001V12M14.0001 6L6.16675 13.8333","stroke":_vm.stroke || 'currentColor',"stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }